import React from 'react';

const Result = ( props ) => {

    const heading = ('' !== (props.heading ?? '')) ? props.heading : 'Results';
    // - - - - - - - - - - - - - - - - - - - - - - - - -

    // ==================================================
    // ==================================================
    return(
        <div className='bg-gray-100 px-6 py-2 -mx-4 -mb-4 flex flex-col gap-2 mt-2'>
            { ('' !== heading) && ('' !== props.result_text) &&
                <>
                <h2 className="text-2xl font-bold">{heading}</h2>
                <p className="card-text">{props.result_text}</p>
                </>
            }
        </div>
    );
};

export default Result;